// extracted by mini-css-extract-plugin
export default {"container":"el","overlay":"fl","videoOverlay":"gl","withHeader":"hl","header":"il","close":"jl","content":"kl"};